/*
 * @Description:
 * @Author: xz
 * @Date: 2023-10-12 18:42:03
 * @LastEditTime: 2023-11-01 08:49:17
 * @LastEditors: xz
 */
import request from '../../utils/request3'
// import request from '../../utils/request'

export default {
  //获取参数和公式
  getFlowParamAndFormulas(params) {
    return request({
      url: '/getFlowdata',
      // url: '/knowledgeGraph/getFlowdata',
      method: 'GET',
      params: params
    })
  },
  //保存自定义参数来源
  addParameterSource(params) {
    return request({
      url: '/postIntoDb',
      method: 'POST',
      data:params
    })
  },
  //保存自定义参数来源
  getFormulaCal(params) {
    return request({
      url: '/formulaCal',
      method: 'POST',
      data:params
    })
  },
  //删除节点
  deleteParamNode(params) {
    return request({
      url: '/deleteNode',
      method: 'GET',
      params:params
    })
  },

  //查找参数的来源
  find_source(params) {
    return request({
      url: '/find_source',
      method: 'GET',
      params:params,
      responseType: 'blob'
    })
  },
}




// WEBPACK FOOTER //
// ./src/api/model.js